export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/admin": [6,[2]],
		"/admin/contractor/[id]": [7,[2]],
		"/admin/manager/[id]": [8,[2]],
		"/app": [9],
		"/contractor": [10,[3]],
		"/contractor/bids": [11,[3]],
		"/contractor/project/[id]": [12,[3]],
		"/contractor/settings": [13,[3]],
		"/contractor/setup": [14,[3]],
		"/manager": [15,[4]],
		"/manager/completed": [16,[4]],
		"/manager/new_project": [17,[4]],
		"/manager/project/[id]": [18,[4]],
		"/manager/settings": [19,[4]],
		"/manager/setup": [20,[4]],
		"/privacy": [21],
		"/signedin": [22],
		"/signin": [23],
		"/terms": [24]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';